document.addEventListener('DOMContentLoaded', function () {
  // Tabs
  document.querySelectorAll('.lf-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var container = btn.closest('.lf-product-tabs');
      container.querySelectorAll('.lf-tab-btn').forEach(function (b) { b.classList.remove('is-active'); });
      container.querySelectorAll('.lf-tab-panel').forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var target = container.querySelector('#' + btn.dataset.tab);
      if (target) target.classList.add('is-active');
    });
  });

    // FAQ
  if (!document._lfFaqReady) {
    document._lfFaqReady = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.lf-faq-question');
      if (btn) {
        btn.closest('.lf-faq-item').classList.toggle('is-open');
      }
    });
  }


  // Sticky ATC
  var atcBtn = document.querySelector('.leafar-product-page .product-form__submit');
  var stickyBar = document.querySelector('.lf-sticky-atc');
  if (atcBtn && stickyBar) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(atcBtn);
    document.querySelectorAll('.lf-sticky-atc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        atcBtn.click();
      });
    });
  }

  // Purchase type toggle
  document.querySelectorAll('.lf-purchase-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      opt.closest('.lf-purchase-type').querySelectorAll('.lf-purchase-option').forEach(function (o) { o.classList.remove('active'); });
      opt.classList.add('active');
    });
  });
});
